"use client";

import Link from "next/link";
import { BrandMark } from "@/components/ui/brand-mark";
import { ThemeToggle } from "@/components/ui/theme-toggle";
import { GuestRoute } from "@/lib/auth/guest-route";

export default function AuthLayout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  return (
    <div className="flex min-h-screen flex-col bg-bg px-4">
      <BrandMark />
      <div className="absolute top-4 right-4">
        <ThemeToggle />
      </div>
      <div className="flex flex-1 items-center justify-center">
        <div className="w-full max-w-md">
          <GuestRoute>{children}</GuestRoute>
        </div>
      </div>
      {/* Slim legal footer — only on the (auth) surface because that
          IS the publicly-reachable edge of the product. Just Imprint
          + Privacy: the §5 TMG / GDPR Art. 13 must-haves. Terms /
          subprocessors / DPO contact live one click deeper (linked
          from the privacy doc) — no need to crowd the sign-in screen
          with every legal artefact we host. */}
      <footer className="border-t border-border py-3 text-xs text-text-tertiary">
        <div className="mx-auto flex max-w-4xl flex-wrap items-center gap-x-4 gap-y-1 px-6">
          <a
            href="https://www.fintum-mi.com/imprint"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-text-primary"
          >
            Imprint
          </a>
          <Link href="/legal/privacy/v1" className="hover:text-text-primary">
            Privacy
          </Link>
          <span className="ml-auto">
            © {new Date().getFullYear()} Fintum Market Intelligence GmbH
          </span>
        </div>
      </footer>
    </div>
  );
}
